import apiService from './api';

export interface YarnName {
  id: number;
  name: string;
  isActive: boolean;
}

// Admin-managed yarn/item-name master. Yarn Inward validates its Item Name against this list.
export const getYarnNames = async (): Promise<YarnName[]> => {
  const res: any = await apiService.get('/yarn-names');
  return (res.yarnNames || []) as YarnName[];
};

export const createYarnName = async (data: { name: string }): Promise<YarnName> => {
  const res: any = await apiService.post('/yarn-names', data);
  return res.yarnName as YarnName;
};

export const deleteYarnName = async (id: number): Promise<void> => {
  await apiService.delete(`/yarn-names/${id}`);
};

// True when the name matches an active master entry — or when the master is empty (not curated
// yet, so nothing is blocked). Mirrors the backend rule.
export const isYarnNameAllowed = (yarnNames: YarnName[], name: string): boolean => {
  const n = (name || '').trim().toLowerCase();
  if (!n) return true; // presence checked separately
  const active = yarnNames.filter((x) => x.isActive);
  if (active.length === 0) return true; // master not curated yet
  return active.some((x) => (x.name || '').trim().toLowerCase() === n);
};
